import styled, { css } from "styled-components/macro";
import { media } from "../../../utils";

const themeTypo = {
  headline: ({ theme, nivel, styleAs }) => ({
    ...theme.typo.headline[`0${styleAs || nivel}`],
  }),
  body: ({ theme, textVariant, textSize }) => ({
    ...theme.typo[`body0${textVariant}`][textSize],
  }),
  lead: ({ theme }) => ({ ...theme.typo.lead.text }),
  caption: ({ theme, textVariant }) => ({
    ...theme.typo.caption[`0${textVariant}`],
  }),
  button: ({ theme, textVariant, textSize }) => ({
    ...theme.typo[`button0${textVariant}`][textSize],
  }),
  link: ({ theme, textVariant, textSize }) => ({
    ...theme.typo[`link${textVariant ? "0" : ""}${textVariant || ""}`][
      textSize
    ],
  }),
};

const getBodyType = (props) => {
  const { reset, textType } = props;

  return {
    ...themeTypo[textType]({ ...props }),
    ...{
      textDecoration: null,
      fontFamily: null,
      marginBottom: null,
      ...reset,
    },
  };
};

export default styled.span`
  ${({ center }) => (center ? css({ textAlign: "center" }) : null)}

  &,
  & > * {
    ${(props) => {
      const { textType, leadMobile } = props;

      const leadThemeBody =
        textType === "headline" && leadMobile
          ? getBodyType({ ...props, textType: "lead" })
          : null;

      const themeBody = getBodyType(props);

      return css({
        ...(leadThemeBody || themeBody),
        [media.md()]: {
          ...(leadThemeBody
            ? {
                ...leadThemeBody,
                ...themeBody,
                textTransform: "none",
                letterSpacing: "0",
              }
            : null),
          ...themeBody.md,
        },
      });
    }}
  }
`;
